import { BaseResponse } from "../../../../../../../types/api/api.types";
import { PROSPECT_ENDPOINTS } from "../../../../../../../utils/api/endpoints/prospectEndpoints";
import { AssignProspectQueryParams } from "./DashboardProspectsDIRAssignTable.types";

const PREFIX = '[assignProspectQuery]';

export const ASSIGN_PROSPECT_QUERY_KEY = 'ASSIGN_PROSPECT';

export const assignProspectQuery = async (params: AssignProspectQueryParams) => {
  console.log(PREFIX, `Fetching assign prospect...`);
  const response = await PROSPECT_ENDPOINTS.assignProspect(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Fetched assign prospect.`);
  return json as BaseResponse;
};